import React from 'react';
export function ProblemaRealSection() {
  return <section className="bg-[#F5F5F5] py-16 md:py-24 px-4" data-id="element-112">
      <div className="max-w-4xl mx-auto text-center md:text-left space-y-8" data-id="element-113">
        <div className="space-y-4 text-xl text-gray-700 max-w-2xl mx-auto md:mx-0" data-id="element-114">
          <p data-id="element-115">
            El problema no es que estés ocupada. Es que gran parte de lo que
            haces… no genera crecimiento.
          </p>
          <br data-id="element-116" />
          <p data-id="element-117">Y mientras no lo veas…</p>
          <br data-id="element-118" />
          <p className="font-bold text-gray-900" data-id="element-119">lo sigues repitiendo.</p>
        </div>

        <div className="space-y-4 text-xl text-gray-700 max-w-2xl mx-auto md:mx-0" data-id="element-120">
          <p className="font-bold text-gray-900" data-id="element-121">
            Cada día que no detectas tus fugas:
          </p>
          <br data-id="element-122" />
          <p data-id="element-123">– pierdes oportunidades</p>
          <p data-id="element-124">– pierdes clientes</p>
          <p data-id="element-125">– pierdes crecimiento</p>
          <br data-id="element-126" />
          <p data-id="element-127">Y lo más peligroso:</p>
          <br data-id="element-128" />
          <p className="font-bold text-gray-900" data-id="element-129">
            no se siente como pérdida… se siente como trabajo.
          </p>
        </div>

        <div className="bg-white border-l-4 border-[#D90B10] p-8 shadow-sm rounded-r-xl my-12 max-w-3xl mx-auto" data-id="element-130">
          <h3 className="text-3xl md:text-4xl font-bold text-gray-900 text-center" data-id="element-131">
            El techo invisible de resultados
          </h3>
        </div>

        <div className="space-y-4 text-xl text-gray-700 max-w-2xl mx-auto md:mx-0" data-id="element-132">
          <p data-id="element-133">Trabajas más.</p>
          <br data-id="element-134" />
          <p data-id="element-135">Pero tu negocio crece menos de lo que podría.</p>
        </div>
      </div>
    </section>;
}